"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_985 = void 0;
var Plan_985 = exports.Plan_985 = {
  planNumber: 985,
  kindOfCover: "Accident & GVE",
  externalName: "Major Medical with Routine Care 80%",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: true,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,200",
  petSpecies: ["CANINE", "FELINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3970",
    "excessNo": 3970
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3971",
    "excessNo": 3971
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3972",
    "excessNo": 3972
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "3973",
    "excessNo": 3973
  }],
  levelsOfCover: [80],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 55,
      "maxAgeDays": 3287,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 30000,
      "formattedAmount": "$30,000",
      "displayValue": "$30,000"
    },
    "paralysisTick": "$3,000 sub-limit",
    "tickParalysis": "$3,000 sub-limit",
    "cruciateLigament": "$5,000 sub-limit",
    "consultationLimit": "$500 sub-limit",
    "consultationsAndVet": "$500 sub-limit",
    "consultationsAndVisits": "$500 sub-limit",
    "consultation": true,
    "emergencyBoardingFees": "$1,200",
    "emergencyBoardingLimit": "$1,200 sub-limit",
    "routineCareLimit": "$145",
    "routineCareLimitBreakDown": [{
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 30
    }, {
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 10
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "DG02955",
      "limit": 10
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 45
    }, {
      "description": "Routine Group",
      "code": "RG10",
      "limit": 50
    }, {
      "description": "Routine Group",
      "code": "RGPIA",
      "limit": 50
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 10
    }]
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding."],
      "waitingPeriod": "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "groomingComplication": true,
    "jointSupplements": false,
    "coversIllness": true,
    "infectiousDisease": true,
    "ingestionOfForeignBodies": true
  },
  isBasePlan: true,
  addOns: ["routineCare"]
};
var _default = exports["default"] = {
  Plan_985: Plan_985
};